import moment from 'moment';
import { Divider, Space, Typography } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import ItemData from '../Item';
import { IBooking, IBookingEvent } from '../../../interfaces/booking.interface';
import { useWorkspaceStore } from '../../../store/workspace.store';

interface Props {
    type?: 'SUCCESS' | 'FAILED' | 'RESOLVING'
    booking: IBooking;
    bookingEvent: IBookingEvent;
}

const { Text } = Typography;

const WayToDeliverStatus = ({
    type = 'SUCCESS', booking, bookingEvent,
}: Props) => {
    const { t } = useTranslation('bookings', { keyPrefix: 'DETAIL' });

    const workspace = useWorkspaceStore((state) => state.data);

    const providerName = workspace?.name;

    const date = moment(bookingEvent?.createdAt).format('DD MMM HH:mm');

    return (
        <div className="booking__status--detail">
            <Space direction="vertical" size={4}>
                <Text className="booking__status--detail-title">
                    {t('STORY_LINE.EVENT_DETAILS')}
                </Text>

                <Text className={`booking__status--detail-tag ${type}`}>
                    {t(`STORY_LINE.${type}`)}
                </Text>
            </Space>

            <Text>
                <Trans
                    t={t}
                    i18nKey="STORY_LINE.STATUS.WAY_TO_DELIVER_DESCRIPTION"
                    components={{ b: <b className="booking__status--bold" /> }}
                    values={{
                        driverName: booking?.driverName,
                        deliveryProvider: providerName,
                        customerName: booking.customerName,
                        deliveryAddress: booking.deliveryAddress,
                    }}
                />
            </Text>

            {
                booking?.distance && booking?.eta && (
                    <Text>
                        <Trans
                            t={t}
                            i18nKey="STORY_LINE.STATUS.WAY_TO_DELIVER_HELP"
                            components={{ b: <b className="booking__status--bold" /> }}
                            values={{
                                driverName: booking?.driverName,
                                ETADistance: booking?.distance,
                                ETATime: booking?.eta,
                            }}
                        />
                    </Text>
                )
            }

            <Text className="booking__status--time">
                {date}
            </Text>

            <Divider />

            <Text className="booking__status--detail-subtitle">
                {t('STORY_LINE.INFORMATION')}
            </Text>

            <div className="booking__status--detail-info">
                <ItemData
                    label={t('CUSTOMER')}
                    value={booking.customerName}
                />
                <ItemData
                    label={t('LOCATIONS.DELIVER')}
                    value={(
                        <Space size={2} direction="vertical">
                            {booking?.deliveryAddress}
                            {
                                (!booking?.deliveryReferences || booking?.deliveryReferences === 'N/A')
                                    ? t('LOCATIONS.NO_REFERENCE')
                                    : booking?.deliveryReferences
                            }
                        </Space>
                    )}
                />
            </div>

        </div>
    );
};

export default WayToDeliverStatus;
